import { useScriptTag } from '@vueuse/core';
import queryString from 'query-string';
import {
  STORAGE_CHANNEL_KEY,
  STORAGE_PLATFORM_KEY,
  STORAGE_TOKEN_KEY,
  USER_INFO_KEY,
} from '@os-web/const';
import { isObject, PromiseWithResolvers, sleep } from '@os-web/utils';
import http, { setHeader } from '@os-web/http';
import { isRegularCustomer } from '@os-web/toufang';
import dayjs from 'dayjs';

const { load: loadSDK } = useScriptTag(
  'https://aicdn.tingzhi66.cn/sense-sdk/latest/sense.sdk.min.js',
  undefined,
  {
    manual: true,
  },
);

const { promise: initPromise, resolve: initResolve } = PromiseWithResolvers();

export const platformNameMap = {
  23: '听芝_安卓版',
  43: '听芝_华为_安卓版',
  59: '听之_IOS版',
  66: '萌宠_iOS版',
};

export class Sense {
  static otherTrackPropertyOpts = {};

  static async init({
    app_id,
    product_id,
    app_version,
    other_attr = {},
    track_property_opts = {},
  }) {
    setHeader('ltvId', product_id);
    const query = queryString.parse(location.search);
    const channel = query.channel || localStorage.getItem(STORAGE_CHANNEL_KEY);
    if (isObject(track_property_opts)) {
      this.otherTrackPropertyOpts = track_property_opts;
    }
    // await appPromiseInit();
    await loadSDK();

    const options = {
      app_id, // 业务线id
      channel, // 渠道号
      single_page: true, // 是否单页应用
      attr: {
        $app_version: app_version,
        ...other_attr,
      },
      auto_track: true,
      product_id: product_id,
      user_center_id: query.u_id,
      show_log: false, // 发送数据时，是否在控制台显示日志信息
      // env: "", // 环境 台湾 tw 美国 mx
    };
    if (localStorage.getItem(STORAGE_TOKEN_KEY)) {
      try {
        const userInfo = await http.get('/v1/user/information');
        localStorage.setItem(
          USER_INFO_KEY,
          JSON.stringify({
            phone: userInfo.phone || '',
          }),
        );
        const registerDay = dayjs().diff(dayjs(userInfo.created_time * 1000), 'day', true);
        options.attr = {
          ...options.attr,
          is_new: registerDay < 3,
          grade: userInfo.level || '',
          extend_3: userInfo.uid || '',
        };
      } catch (error) {
        console.error(error);
      }
    }

    window.sense.init(options);
    await sleep(1000);
    initResolve();
  }

  static async track(eventName, properties = {}) {
    await initPromise;
    const platform = localStorage.getItem(STORAGE_PLATFORM_KEY);
    const _properties = {
      source: location.href,
      is_log: localStorage.getItem(STORAGE_TOKEN_KEY) ? '是' : '否', //是否已登陆
      platform: localStorage.getItem(STORAGE_PLATFORM_KEY),
      platform_name: platformNameMap[platform],
      ...properties,
    };

    if (this.otherTrackPropertyOpts?.has_toufang_is_lock) {
      _properties.is_lock = (await isRegularCustomer()) ? '是' : '否'; //是否老用户价
    }

    window.sense.track(eventName, _properties);
  }
}

export default Sense;
